import type { IPercentObject } from '../models';

export const transformValue = (value: number | string | IPercentObject) => {
    if (typeof value === 'string') {
        const regex = /(\d+)(?:[,.](\d+))?\s*%/;
        const [, firstPart, secondPart] = value.match(regex) || [];

        return parseFloat(secondPart ? `${firstPart}.${secondPart}` : `${firstPart}`) || 1;
    }

    return value;
};
